module.exports = __webpack_public_path__ + "img/template-eight-around.8f58cd55.png";